import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//@componnets
import { OKMessage } from 'commonsComponents/OKMessage';
import { OKLink } from 'commonsComponents/OKLink';
import FormattedTextWithComponents from 'components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents';
const { FormattedText } = require('core/i18n').i18n;

//@constants
import { SHOW_SUITABILITY_TEST_EXPIRATION_NOTICE } from 'constants/flagBasedFeatures';

class RATestExpirationDisclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTestExpiredAlert: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { immCheckStatus, flagBasedFeatures } = this.props;

        if (
            prevProps.immCheckStatus.get('isFetchingCheckStatus') &&
            !immCheckStatus.get('isFetchingCheckStatus')
        ) {
            if (
                !immCheckStatus.get('expirationDate') ||
                !flagBasedFeatures.get(
                    SHOW_SUITABILITY_TEST_EXPIRATION_NOTICE,
                ) ||
                !immCheckStatus.get('activeRoboCustomer')
            ) {
                this.setState({ showTestExpiredAlert: false });
            } else {
                const expirationDate = moment(
                    immCheckStatus.get('expirationDate'),
                );
                const currentDate = moment().format('YYYY-MM-DD');
                if (expirationDate.isBefore(currentDate)) {
                    this.setState({ showTestExpiredAlert: true });
                }
            }
        }
    }

    render() {
        const { showTestExpiredAlert } = this.state;
        const testExpiredLink = (
            <OKLink to={'/myprofile/robo/testStatus'} modifier="emphasize">
                <FormattedText value="raTestExpiredDisclaimer-linkText" />
            </OKLink>
        );
        const testExpiredText = (
            <FormattedTextWithComponents
                value={'raTestExpiredDisclaimer-content'}
                injectedComponents={[testExpiredLink]}
            />
        );
        return (
            <div className>
                <OKMessage
                    type="informative"
                    modifier="dark-bg"
                    closeButton
                    visible={showTestExpiredAlert}
                    onCloseButtonClick={() =>
                        this.setState({ showTestExpiredAlert: false })
                    }
                >
                    <FormattedText value="raTestExpiredDisclaimer-title" />
                    <br />
                    {testExpiredText}
                </OKMessage>
            </div>
        );
    }
}

RATestExpirationDisclaimer.propTypes = {
    immCheckStatus: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immCheckStatus: state.raCheckStatus,
    }),
    {},
)(withRouter(RATestExpirationDisclaimer));
